var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 12.8195V14.4861M13.2898 4.59431C12.4208 2.46351 9.98895 1.44062 7.85815 2.30961C5.72735 3.17861 4.5 5.23615 5.57345 7.74122C5.86762 8.45766 5.79186 9.0961 5.79186 9.0961M5.79186 9.0961C6.19199 9.06947 6.68838 9.06947 7.33331 9.06947H12.6666C14.0668 9.06947 14.7668 9.06947 15.3016 9.34195C15.772 9.58163 16.1545 9.96409 16.3942 10.4345C16.6666 10.9693 16.6666 11.6693 16.6666 13.0695V14.2361C16.6666 15.6363 16.6666 16.3363 16.3942 16.8711C16.1545 17.3415 15.772 17.724 15.3016 17.9637C14.7668 18.2361 14.0668 18.2361 12.6666 18.2361H7.33331C5.93318 18.2361 5.23312 18.2361 4.69834 17.9637C4.22793 17.724 3.84548 17.3415 3.6058 16.8711C3.33331 16.3363 3.33331 15.6363 3.33331 14.2361V13.0695C3.33331 11.6693 3.33331 10.9693 3.6058 10.4345C3.84548 9.96409 4.22793 9.58163 4.69834 9.34195C4.98679 9.19498 5.32332 9.12728 5.79186 9.0961Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.5a1191a0abe15546fe495919e9f114ea.svg";
export { ForwardRef as ReactComponent };